<template>
  <div class="card-holding-container">
    <b-row
      v-if="loaded && customersList.length"
      class="change-view-row"
    >
      <div class="grid-icon-container normalize-zIndex">
        <img
          v-if="!showListView"
          @click="showListView = !showListView"
          src="@/assets/icons/card_grid.svg"
          alt
          class="cursor-pointer"
        />
        <img
          v-if="showListView"
          @click="showListView = !showListView"
          src="@/assets/icons/card_list.svg"
          alt
          class="cursor-pointer"
        />
      </div>
    </b-row>
    <div v-if="!showListView" class="d-flex grid-card-wrapper">
      <b-row class="w-100 d-flex flex-column" no-gutters>
        <b-row>
          <b-col
            cols="6"
            md="4"
            lg="4"
            xl="3"
            v-for="customer in customersList"
            :key="customer.customer.profile.id"
          >
            <b-card
              @click="navigate(customer.customer.profile)"
              @mouseenter="showCardHover(customer.customer.profile.id)"
              @mouseleave="undoCardHover(customer.customer.profile.id)"
              class="grid-card mb-5 px-0"
            >
              <div
                class="d-flex justify-content-end"
                style="min-height: 4.4rem"
              ></div>
              <b-card-body class="text-center grid-card-body position-relative">
                <b-avatar
                  class="customers-grid-avatar"
                  v-if="customer.customer.profile.user.avatarThumbnail"
                  size="12rem"
                  :src="customer.customer.profile.user.avatarThumbnail"
                ></b-avatar>
                <b-avatar
                  class="customers-grid-avatar bg--primary"
                  v-else
                  size="12rem"
                  :text="
                    getInitials(
                      `${customer.customer.profile.user.firstName} ${customer.customer.profile.user.lastName}`
                    )
                  "
                ></b-avatar>

                <p class="primary--text font-family-medium mt-4">
                  {{
                    ellipsify(
                      `${customer.customer.profile.user.firstName} ${customer.customer.profile.user.lastName}`,
                      25
                    )
                  }}
                </p>
                <div class="d-flex justify-content-center reduce-whitespace-2">
                  <b-button
                    class="text-uppercase mr-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                    >{{
                      getMembershipTitle(customer.customer.profile.customerProfile)
                    }}</b-button
                  >
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <infinite-loading
          spinner="spiral"
          @infinite="infiniteHandlerDedicatedCustomers"
          :identifier="infiniteId"
          ><div slot="no-more">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div>
          <div slot="no-results">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div></infinite-loading
        >
      </b-row>
    </div>
    <b-row
      v-if="showListView"
      class="d-flex grid-list-wrapper position-relative mb-4"
    >
      <b-col>
        <b-row
          :class="[customersList.length === 1 ? 'w-50' : 'w-100']"
          class="mx-0 justify-content-between py-0 px-5"
        >
          <h6
            class="font-sm position-relative primary--text font-family-medium"
          >
            Customer
          </h6>
        </b-row>
      </b-col>
      <b-col v-if="customersList.length > 1">
        <b-row class="w-100 mx-0 justify-content-between py-0 px-5">
          <h6
            class="font-sm position-relative primary--text font-family-medium"
          >
            Customer
          </h6>
        </b-row>
      </b-col>
      <b-row class="w-100 mx-0">
        <b-col
          md="6"
          v-for="customer in customersList"
          :key="customer.customer.profile.id"
        >
          <b-card
            @click="navigate(customer.customer.profile)"
            class="mt-5 px-0"
            @mouseenter="showCardHover(customer.customer.profile.id)"
            @mouseleave="undoCardHover(customer.customer.profile.id)"
          >
            <b-card-body class="d-flex text-center grid-list-card-body">
              <div>
                <b-avatar
                  size="8rem"
                  v-if="customer.customer.profile.user.avatarThumbnail"
                  class="customers-grid-avatar"
                  :src="customer.customer.profile.user.avatarThumbnail"
                ></b-avatar>
                <b-avatar
                  size="8rem"
                  v-else
                  class="customers-grid-avatar bg--primary"
                  :text="
                    getInitials(
                      `${customer.customer.profile.user.firstName} ${customer.customer.profile.user.lastName}`
                    )
                  "
                ></b-avatar>
              </div>
              <div
                class="d-flex flex-column align-items-start justify-content-center ml-4"
              >
                <p class="font-family-medium primary--text">
                  {{
                    `${customer.customer.profile.user.firstName} ${customer.customer.profile.user.lastName}`
                  }}
                </p>
                <div class="d-flex justify-content-center reduce-whitespace-2">
                  <b-button
                    class="text-uppercase mr-2 btn-chip btn-danger--light danger font-family-regular btn-chip--pill"
                    >{{
                      getMembershipTitle(customer.customer.profile.customerProfile)
                    }}</b-button
                  >
                </div>
              </div>
              <div class="notification-btn-list-container"></div>
            </b-card-body>
          </b-card>
        </b-col>
        <infinite-loading
          spinner="spiral"
          style="width:100%"
          @infinite="infiniteHandlerDedicatedCustomers"
          :identifier="infiniteId"
          ><div slot="no-more">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div>
          <div slot="no-results">
            <h4 class="primary--text font-family-medium mb-5 mt-5">
              No more customers to load.
            </h4>
          </div></infinite-loading
        >
      </b-row>
    </b-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getAssistantCustomers } from "@/apis/customers";
import { getInitials, ellipsify } from "@/utils/utils";
import { internalCustomerEmailSet } from "@/utils/constants";
export default {
  name: "PACustomers",
  computed: {
    ...mapState("authModule", ["role", "profileUserId"])
  },
  data() {
    return {
      offset: 0,
      customersList: [],
      loaded: false,
      infiniteId: +new Date(),
      showListView: false,
      expandHover: false,
      activeExpandHoverId: "",
      inactiveExpandHoverId: "",
      showInactiveExpandHover: true
    };
  },
  methods: {
    getInitials,
    ellipsify,
    getMembershipTitle(customerProfile) {
      return customerProfile.membership
        ? customerProfile.membership.title
        : "N/A";
    },
    infiniteHandlerDedicatedCustomers($state) {
      const params = {
        customer__is_active: true,
        limit: 30,
        offset: this.offset
      };
      getAssistantCustomers(this.$route.params.uuid, params)
        .then(res => {
          this.loaded = true;
          this.customersList = [
            ...this.customersList,
            ...res.data.results
          ].filter(
            el => !internalCustomerEmailSet.has(el.customer.profile.user.email)
          );
          this.offset = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    showCardHover(id) {
      this.activeExpandHoverId = id;
      this.expandHover = true;
      this.showInactiveExpandHover = true;
    },
    undoCardHover(id) {
      this.inactiveExpandHoverId = id;
      this.expandHover = false;
    },
    navigate(customer) {
      this.$router.push({
        name: "PACustomerDetails",
        params: {
          uuid: this.$route.params.uuid,
          profileId: customer.id
        },
        query: {
          tab: 2
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.grid-list-wrapper {
}
.skeleton-loader-pa-customers {
  margin-top: 8rem;
}
.grid-list-card-body {
  padding: 1rem 0.5rem !important;
}
.grid-list-action-icons {
  margin-top: -1.5rem;
  top: 40%;
  right: 0;
}
.grid-icon-container {
  right: 0;
}
.grid-row {
  margin-top: 5rem;
}
.expand-right {
  right: 1.5rem;
}
.card {
  cursor: pointer;
}
.change-view-row {
  padding: 0 15px 2.5rem 0;
  >div {
    margin-left: auto;
  }
}
.card-holding-container {
  padding: 2.5rem;
  margin-top: 3rem;
}
</style>
